import { Link, useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Phone, Menu, X } from "lucide-react";
import { useState } from "react";

const WebsiteHeader = () => {
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  
  const navItems = [
    { path: "/site", label: "Home" },
    { path: "/site/products", label: "Products" },
    { path: "/site/promotions", label: "Specials" },
    { path: "/site/about", label: "About Us" },
    { path: "/site/contact", label: "Contact" },
  ];
  
  const isActive = (path) => {
    if (path === "/site") return location.pathname === "/site";
    return location.pathname.startsWith(path);
  };

  return (
    <header className="bg-slate-900 text-white sticky top-0 z-50 shadow-lg">
      <div className="container mx-auto px-4">
        {/* Top Bar */}
        <div className="flex items-center justify-between py-2 border-b border-slate-700 text-sm">
          <div className="flex items-center gap-4">
            <span className="text-gray-400">Mon-Sat: 07:30 - 18:00</span>
            <span className="hidden sm:inline text-gray-400">|</span>
            <a 
              href="tel:0832785937" 
              className="hidden sm:flex items-center gap-1 text-blue-400 hover:text-blue-300"
            >
              <Phone className="h-3 w-3" />
              083 278 5937
            </a>
          </div>
          <Link to="/" className="text-xs text-gray-400 hover:text-white">
            Staff Login →
          </Link>
        </div>
        
        {/* Main Nav */}
        <div className="flex items-center justify-between py-3">
          <Link to="/site" className="flex items-center gap-3">
            <img 
              src="/logo.jpg" 
              alt="BBH Logo" 
              className="h-12 rounded bg-white p-1"
            />
            <div className="hidden sm:block">
              <p className="font-bold text-lg leading-tight">BOSVELD BOU</p>
              <p className="text-xs text-blue-400">& HARDEWARE</p>
            </div>
          </Link>
          
          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-1">
            {navItems.map((item) => (
              <Link key={item.path} to={item.path}>
                <Button 
                  variant="ghost" 
                  className={`text-white hover:bg-white/10 ${
                    isActive(item.path) ? "bg-white/10 text-blue-400" : ""
                  }`}
                >
                  {item.label}
                </Button>
              </Link>
            ))}
          </nav>
          
          {/* Mobile Menu Button */}
          <Button 
            variant="ghost" 
            className="md:hidden text-white"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </Button>
        </div>
        
        {/* Mobile Nav */}
        {mobileMenuOpen && (
          <nav className="md:hidden py-4 border-t border-slate-700">
            {navItems.map((item) => (
              <Link 
                key={item.path} 
                to={item.path}
                onClick={() => setMobileMenuOpen(false)}
                className={`block py-3 px-4 rounded ${
                  isActive(item.path) 
                    ? "bg-white/10 text-blue-400" 
                    : "text-white hover:bg-white/5"
                }`}
              >
                {item.label}
              </Link>
            ))}
          </nav>
        )}
      </div>
    </header>
  );
};

export default WebsiteHeader;
